import styled from 'styled-components';

import {FormControl, useToast} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import useFeedback from "../../../utils/use_feedback";
import FormContainer from "../../../components/form_container";
import {useSaveClicked} from "../../../store";
import {useCreateImage, useUploadToken} from "../../../api/create_image";

const UploadText = styled.div``;
const SwitchHeading = styled.div``;

const ProfileSettings = styled(({className}) => {

    const {error, busy, feedbackCh} = useFeedback();
    const [picture, setPicture] = useState(null);

    const uploadToken = useUploadToken(feedbackCh);
    const setProfilePicture = useCreateImage(feedbackCh);

    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);

    const toast = useToast();
    const history = useHistory();

    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    setSaving(true);
                    toast({
                        title: `Saving...`,
                        status: 'info',
                        isClosable: true,
                    });
                    if (picture) {
                        const token = await uploadToken('profilePicture');
                        await setProfilePicture(picture, token);
                    }
                    toast({
                        title: `Updated profile picture.`,
                        status: 'success',
                        isClosable: true,
                    });
                    setSaving(false);
                    history.goBack();
                }
            }
        })().then(() => {
        }, () => {
        });
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Profile" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>

                        <SwitchHeading>Profile Picture</SwitchHeading>
                        <p>Please refer to the <a href={"https://help.scored.co/knowledge-base/profile-picture-policy/"} target={"_blank"}>Profile Picture policy</a> before
                        uploading.</p>
                        <FormControl style={{marginTop: '12px'}}>
                            <input type={"file"} onChange = {(e) => setPicture(e.target.files[0])}/>
                        </FormControl>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
  p {
    font-size: 13px;
    padding-bottom: 12px;
  }
  ${SwitchHeading} {
    font-weight: 600;
    font-size: 14px;
  }
`;

export default ProfileSettings;
